import { apiSlice } from '../api/api-slice';
import { PartnerContactInformationFlatViewModel, PaginatedResult } from '../api/models';

export interface PartnerContactInformationFlatListRequest {
  pageSize: number;
  filter?: string | null;
  current: number;
  total?: number;
  sortBy?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
  searchText?: string | null;
  filterJson?: string | null;
  missingContactType?: string | null;
}

export const partnercontactinformationflatApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      fetchPartnerContactInformationFlat: builder.query<
        PaginatedResult<PartnerContactInformationFlatViewModel>,
        PartnerContactInformationFlatListRequest
      >({
        query({ current, pageSize, filter, sortColumn, sortDirection, searchText, filterJson, missingContactType }) {
          const params = new URLSearchParams();
          params.append('pageNumber', current.toString());
          params.append('pageSize', pageSize.toString());
          if (sortColumn) params.append('sortColumn', sortColumn);
          if (sortDirection) params.append('sortDirection', sortDirection);
          if (searchText) params.append('searchText', searchText);
          if (filterJson) params.append('filterJson', filterJson);
          if (filter) params.append('filter', filter);
          if (missingContactType) params.append('missingContactType', missingContactType);
          return `/partnershipInformationContacts/partner-contact-flat?${params.toString()}`;
        },
        forceRefetch() {
          return true;
        },
        providesTags: ['PartnerContactInformationFlat'],
      }),
    };
  },
});

export const { useFetchPartnerContactInformationFlatQuery } = partnercontactinformationflatApi;
